import { render } from "./VueNewsPage.vue?vue&type=template&id=860f44b8&ts=true&lang=pug"
import script from "./VueNewsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueNewsPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/public/VueNewsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "860f44b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('860f44b8', __exports__)) {
    api.reload('860f44b8', __exports__)
  }
  
  module.hot.accept("./VueNewsPage.vue?vue&type=template&id=860f44b8&ts=true&lang=pug", () => {
    api.rerender('860f44b8', render)
  })

}


export default __exports__